module.exports = __webpack_public_path__ + "static/media/icn-down-grey.33201016.svg";